export const QUESTION = 'Customer Reviews'

export const CUSTOMER_REVIEW = {
  author: 'Luke Gorman',
  text: 'purchase.customerReviews.secondReviewText',
}
